import {
    FIFTY_DISCOUNT,
    THIRTY_DISCOUNT,
    TEN_DISCOUNT,
    IS_CONTINUE,
    COMMON,
    LIMIT_OVER,
    DELETE_CONFIRM,
    IS_DELETE_CONTINUE,
    PROHIBITED,
    PROHIBITED_ITEM,
    NBPBKBN,
    EXCEL_VALIDATION,
    SHOW_TABLE_LIMIT_OVER,
    IS_EDLP_CONTINUE,
    EDLP,
    PRICE_VALID,
    IS_PRICE_VALID_CONTINUE,
    BAIKA,
    EXPORT_ERROR,
    VARIANT_PRODUCTS,
    IS_VARIANT_PRODUCTS_CONTINUE,
} from '../actions/type';

const initialState = {
    isContinue: false, // 申請・編集続行
    // 50%乖離
    fiftyDiscount: {
        isShow: false,
        items: [],
    },
    // 30%乖離
    thirtyDiscount: {
        isShow: false,
        items: [],
    },
    // 10%乖離
    tenDiscount: {
        isShow: false,
        items: [],
    },
    isDeleteContinue: false, // 削除続行
    isEdlpContinue: false, // edlp続行
    isPriceValidContinue: false, // 更徳続行
    deleteConfirm: false, // 削除確認
    // 下限値超過
    limitOver: {
        isShow: false,
        items: [],
    },
    // 下限値超過
    showTableLimitOver: {
        isShow: false,
        items: [],
    },
    // 禁止カテゴリー
    prohibited: {
        isShow: false,
        items: [],
    },
    // 禁止商品
    prohibitedItem: {
        isShow: false,
        items: [],
    },
    // PB/留型
    nbpbkbn: {
        isShow: false,
        items: [],
    },
    // EDLP
    edlp: {
        isShow: false,
        items: [],
    },
    // 更徳
    priceValid: {
        isShow: false,
        items: [],
    },
    // 売価
    baika: {
        isShow: false,
        items: [],
    },
    // Excelバリデーション
    excelValidation: {
        isShow: false,
        items: [],
    },
    // 共通
    common: {
        isShow: false,
        title: '',
        body: '',
    },
    exportError: {
        isShow: false,
        title: 'ダウンロードエラー',
        text01: '１度にダウンロードできる件数は7,000件です。期間を変更してお試しください。',
    },
    // 類似商品
    variantProducts: {
        isShow: false,
        items: [],
    },
    // 類似商品続行
    isVariantProductsContinue: false,
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case IS_CONTINUE:
            return {
                ...state,
                isContinue: action.data,
            };
        case FIFTY_DISCOUNT:
            return {
                ...state,
                fiftyDiscount: action.data,
            };
        case THIRTY_DISCOUNT:
            return {
                ...state,
                thirtyDiscount: action.data,
            };
        case TEN_DISCOUNT:
            return {
                ...state,
                tenDiscount: action.data,
            };
        case LIMIT_OVER:
            return {
                ...state,
                limitOver: action.data,
            };
        case SHOW_TABLE_LIMIT_OVER:
            return {
                ...state,
                showTableLimitOver: action.data,
            };
        case PROHIBITED:
            return {
                ...state,
                prohibited: action.data,
            };
        case PROHIBITED_ITEM:
            return {
                ...state,
                prohibitedItem: action.data,
            };
        case NBPBKBN:
            return {
                ...state,
                nbpbkbn: action.data,
            };
        case EXCEL_VALIDATION:
            return {
                ...state,
                excelValidation: action.data,
            };
        case IS_DELETE_CONTINUE:
            return {
                ...state,
                isDeleteContinue: action.data,
            };
        case DELETE_CONFIRM:
            return {
                ...state,
                deleteConfirm: action.data,
            };
        case COMMON:
            return {
                ...state,
                common: action.data,
            };
        case EDLP:
            return {
                ...state,
                edlp: action.data,
            };
        case IS_EDLP_CONTINUE:
            return {
                ...state,
                isEdlpContinue: action.data,
            };
        case PRICE_VALID:
            return {
                ...state,
                priceValid: action.data,
            };
        case IS_PRICE_VALID_CONTINUE:
            return {
                ...state,
                isPriceValidContinue: action.data,
            };
        case BAIKA:
            return {
                ...state,
                baika: action.data,
            };
        case EXPORT_ERROR:
            return {
                ...state,
                exportError: action.data,
            };
        case VARIANT_PRODUCTS:
            return {
                ...state,
                variantProducts: action.data,
            };
        case IS_VARIANT_PRODUCTS_CONTINUE:
            return {
                ...state,
                isVariantProductsContinue: action.data,
            };
        default:
            return state;
    }
};

export { modalReducer };
